/**
 * SEO TDK 配置（单一数据源）
 *
 * 路由 meta 和构建脚本都从这里读取，改 TDK 只需改这一个文件。
 */

// 各路由的 TDK 配置，key 为路由 path
export const seoConfig = {
  '/home': {
    title: '端侧AI大模型-AI音频算法-AI视觉算法-ai大模型厂家 | 移远通信',
    keywords: '端侧AI大模型,AI音频算法,AI视觉算法,ai大模型厂家,移远通信',
    description:
      'ai大模型厂家移远通信-全球物联网整体解决方案供应商多种AI算法"即取即用"。提供全面的AI算法支持，涵盖计算机视觉、自然语言处理、音频算法等多个领域，包含：端侧AI大模型、AI音频算法、AI视觉算法、ai大模型等AI生态产品。',
  },
  '/omni-train': {
    title: '开放训练平台-Omni Train | 移远通信',
    keywords: 'Omni Train,开放训练平台,模型训练,数据标注,算法管理,模型交付',
    description: 'Omni Train 开放训练平台从原始数据到可交付模型，每个环节保留上下文、版本与运行记录，让实验可以复现，让结果可以继续交付。',
  },
  '/datahub': {
    title: 'DataHub-AI项目资产工作台 | 移远通信',
    keywords: 'DataHub,AI项目资产,数据集管理,Skills Hub,组织协作,权限治理',
    description: 'DataHub 将数据集、Skills Hub、组织空间和权限策略统一到一个工作台，帮助团队快速发现可信资产，完成上传、预览、检测、协作和交付。',
  },
  '/memcore/intro': {
    title: 'MemCore记忆引擎-智能体长期记忆引擎 | 移远通信',
    keywords: 'MemCore,长期记忆,记忆引擎,智能体,记忆图谱',
    description: 'MemCore 将零散对话、项目决策和协作经验沉淀为可追溯、可关联、可复用的长期记忆，让每个智能体都拥有真正理解你的上下文。',
  },
  '/ai-playground': {
    title: 'AI Playground端侧AI体验平台-Quectel Pi H1 | 移远通信',
    keywords: 'AI Playground,Quectel Pi H1,端侧AI,NPU推理,视觉算法体验',
    description: 'AI Playground 是面向 Quectel Pi H1 的端侧 AI 推理演示平台，内置10个场景化算法模块，支持图片、视频和摄像头输入、性能监控及推理结果导出。',
  },
  '/uniclaw': {
    title: 'UniClaw边缘AI Agent框架-Agentic IoT-AI开放平台 | 移远通信',
    keywords: 'UniClaw,边缘AI Agent,Agentic IoT,AI Agent框架,IoT智能体',
    description:
      'UniClaw 是面向 MCU、SoC 与 PC 的通用边缘AIAgent 框架，支持端云融合 Agent、聊天即造物、本地记忆、MCP 扩展与 IoT 本地控制。',
  },
  '/uniclaw/flash': {
    title: 'UniClaw在线烧录-网页端固件烧录-AI开放平台 | 移远通信',
    keywords: 'UniClaw在线烧录,网页端烧录,固件烧录,Web Serial,边缘AI设备',
    description:
      'UniClaw 在线烧录页面支持硬件选择、设备连接、授权校验、固件写入、进度日志与错误恢复提示，帮助开发者快速完成设备部署。',
  },
  '/uniclaw/auth': {
    title: 'UniClaw授权码-授权码申请查询验证-AI开放平台 | 移远通信',
    keywords: 'UniClaw授权码,授权码申请,授权码查询,授权码验证,设备授权',
    description:
      'UniClaw 授权码中心提供授权码申请、自动发放、查询、验证与使用记录展示，便于开发者快速获取在线烧录授权。',
  },
  '/uniclaw/docs': {
    title: 'UniClaw文档中心-快速开始-使用指南-开发参考 | 移远通信',
    keywords:
      'UniClaw文档,UniClaw快速开始,UniClaw使用指南,UniClaw开发参考,MCP接入',
    description:
      'UniClaw 文档中心提供快速开始、使用指南与开发参考，覆盖在线烧录、授权码、技能配置、MCP 接入、HAL 适配和固件协议。',
  },
  '/core_capabilities/edge_ai': {
    title: 'AI大模型-端侧AI部署-移远通信',
    keywords: '端侧AI大模型,端侧AI部署,移远通信',
    description:
      '移远通信的端侧AI大模型基于高通QCS8550平台的强劲算力支撑和部署,设备可在无网环境下稳定运行核心功能,包括通用聊天、检索增强生成（RAG）、基于人机协同的RAG应答、基于模型微调的意图识别以及路由等。',
  },
  '/core_capabilities/ai_audio': {
    title: 'AI音频算法-AI语音降噪算法-移远通信',
    keywords: 'AI音频算法，AI语音降噪算法，移远通信',
    description:
      '移远通信全链路AI音频算法，适配 RTOS、Linux、Android 及移远模组平台，大幅降低集成成本与周期，保障多场景音频智能功能稳定落地，具备噪声抑制，回声消除，自动增益控制，人声检测，声源定位，波束成形等特点。',
  },
  '/core_capabilities/ai_vision': {
    title: 'AI视觉算法-AI视觉算法平台-移远通信',
    keywords: 'AI视觉算法，AI视觉算法平台，移远通信',
    description:
      '移远通信以强大的AI视觉算法能力，打造场景化智能新生态，旗下AI视觉算法全链路平台覆盖数据清洗、模型选型、模型训练、边缘部署到应用开发的全流程，模型转换支持多种AI框架，助力多样化AI业务场景应用落地。',
  },
  '/solutions/smart_vending_machine': {
    title: 'AI智能无人零售-AI智能无人零售解决方案-移远通信',
    keywords: 'AI 智能无人零售，AI 智能无人零售解决方案，移远通信',
    description:
      '移远通信推出的OpenVending AI智能无人零售解决方案顺应发展，以先进的动态视觉与AI算力，精准捕捉商品信息，实现实时分析与决策，以AI视觉为核心解决行业痛点，真正做到了AI智能无人零售场景。',
  },
  '/solutions/audio_modules': {
    title: '移远AI音频模组-AI音频模组解决方案',
    keywords: 'AI音频模组，移远AI音频模组，AI音频模组解决方案',
    description:
      '移远通信AI音频模组及AI音频模组解决方案聚焦端侧智能与离线感知，基于 VA500-GL 模组，支持全离线语音唤醒与指令识别，响应 <100ms，并创新实现环境状态 (安静 / 说话 / 鼾声 / 嘈杂) 主动检测，联动设备进行智能调节，给智能家居赋能。',
  },
  '/solutions/robrain': {
    title: '智能ai机器人-RobrainAI机器人-移动解决方案',
    keywords: '智能ai机器人，RobrainAI机器人，移动解决方案',
    description:
      '智能 AI 机器人及 Robrain AI 机器人解决方案聚焦端侧智能与多模态交互，依托高算力 AI 模组与端云协同架构，整合视觉、语音、文本大模型，突破实时响应瓶颈，方案还支持断网运行与私有化部署，精准实现动作控制、声纹识别与复杂指令理解。',
  },
  '/solutions/smart_scale': {
    title: 'AI智能识别秤解决方案-移远通信AI智能识别秤',
    keywords: 'AI智能识别秤解决方案,移远通信AI智能识别秤',
    description:
      '移远通信的AI智能识别秤解决方案依靠AI智能识别秤大幅优化称重收银效率，基于深度学习与AI视觉算法，实现 0.1 秒极速识别超 1000 种商品，准确率高达 99%，方案还支持灵活模组部署与模型在线升级。',
  },
  '/solutions/smart_toys': {
    title: 'AI玩具解决方案-AI玩具产品赋能-移远通信',
    keywords: 'AI玩具解决方案,AI玩具产品赋能,移远通信',
    description:
      '移远通信推出AI玩具解决方案，以“连接+AI大模型+音频算法+IoT平台”一站式服务赋能AI玩具产品，方案聚焦稳定连接、多模态情绪识别与拟人化反馈，让玩具能听懂并回应情绪，现已和多家企业达成合作。',
  },
  '/algostore': {
    title: '视觉识别算法-智能视觉算法-移远算法超市',
    keywords: '视觉识别算法，智能视觉算法，移远算法超市',
    description:
      'AlgoStore算法超市是移远通信搭建的一站式算法服务平台，视觉算法包括：智能视觉识别算法、视觉手势识别算法和自动驾驶视觉算法等等，分为人体识别、人脸识别、光学字符识别等等，共计10大类，66小类。',
  },
  '/algostore/body_driver_monitoring': {
    title: '驾驶行为分析-自动驾驶视觉算法-AI开放平台 | 移远通信',
    keywords: '驾驶行为分析,自动驾驶视觉算法,AI开放平台',
    description:
      '移远通信-全球物联网整体解决方案供应商提供全面的AI开放平台，自动驾驶视觉算法、驾驶行为分析通过图像识别技术分析驾驶员操作及状态。具有：行为模式学习、安全预警提示、数据驱动改进等特点。',
    prerenderQuery: { id: '13' },
  },
  '/algostore/face_emotion': {
    title: '情绪识别-智能人脸识别模组-AI开放平台 | 移远通信',
    keywords: '情绪识别,人脸识别模组,智能人脸识别模组,AI开放平台',
    description:
      '移远通信-全球物联网整体解决方案供应商提供全面的AI开放平台，智能人脸识别模组、情绪识别通过分析面部表情等来判断人的情绪状态。具有：多种情绪分类、实时分析能力、高准确度识别等特点。',
    prerenderQuery: { id: '5' },
  },
  '/algostore/body_gesture_recognition': {
    title: '手势识别-视觉手势识别算法-机器视觉识别算法-AI开放平台 | 移远通信',
    keywords: '视觉手势识别算法,机器视觉识别算法,AI开放平台',
    description:
      '移远通信-全球物联网整体解决方案供应商提供全面的AI开放平台，手势识别、视觉手势识别算法、机器视觉识别算法通过图像识别技术获取用户对应手势以进行对应操作。具有：实时识别反馈、动作捕捉精准等特点。',
    prerenderQuery: { id: '15' },
  },
  '/algostore/face_landmarks_detection': {
    title: '人脸关键点-人脸识别模组-视觉识别算法-AI开放平台 | 移远通信',
    keywords: '人脸识别模组,视觉识别算法,AI开放平台',
    description:
      '移远通信提供全面的AI开放平台，人脸识别模组、视觉识别算法、人脸关键点通过检测人脸五官与轮廓的关键点及位置，关键点包括人脸轮廓、眼睛、眉毛、嘴唇以及鼻子轮廓。具有：精确位置标记、自适应光照变、支持多种表情等特点。',
    prerenderQuery: { id: '2' },
  },
}
